module.exports = __webpack_public_path__ + "img/icon-founded.7109a24c.svg";